import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Plot from 'react-plotly.js';
import {
  ManRadioButtonGroup,
  ManRadioButton,
  ManText
} from '@craft-design-system/core-components-react';
import Shimmer_graph from '../shimmer_graph';
import { useResetContext } from '../ResetContext';
import useGraphRadio from '../../utils/useGraphRadio';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import AverageDisplay from '../ride_analysis_kpi/Average_value';
import DownloadButtonComponent from '../DownloadButtonComponent';
import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';
import { CustomTextDisplay } from '../AI';
import Zoom from '../Zoom';
import ifav from './ifav.png';

const Charging_session_count = ({ value }) => {
  const [charging_session_count, set_charging_session_count] = useState(null);
  const [downloadData, setDownloadData] = useState([]);
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [chartType, setChartType] = useState("Bar");
  const { resetdata } = useResetContext();
  const radio_query = useGraphRadio();
  const { fetchSegmentedChart } = useSegmentedChartQuery();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [avg_value, setavg_value] = useState(
    value?.chargingSessionCount?.[2]?.average || 0
  );

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        This KPI displays the sum of charging sessions on daily / monthly / yearly basis.<br /><br />
  
        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3:<br />
        • highvoltsysmode<br />
        • batterycurrent<br />
        • energylevel<br />
        CM4:<br />
        • highvoltsysmode<br />
        • batterycurrent<br />
        • batcurrcbp<br />
        • energylevel<br />
        • energylevelcbp<br /><br />
  
        <strong>Time series data:</strong><br />
        If multiple vehicles are selected, average values are displayed. Days without data are not taken into account for the calculation.
      </Popover.Body>
    </Popover>
  );
  const handleSelectChange1 = (event) => {
    set_Radio_values((prevValues) => ({
      ...prevValues,
      [event.detail.name]: event.detail.value,
    }));
  };



  useEffect(() => {
    if (radio_buttons_test) {
      setIsLoading(true);
      radio_query({
        vins_short: [value.vin_short],
        radio_value: radio_buttons_test,
        columnname: 'Charging Session Count',
        category: resetdata,
        chartType,
      }).then(data => {
        set_charging_session_count(JSON.parse(data['jsonData'][0]));
        setavg_value(data['jsonData'][2]?.average || 0);
        setDownloadData(JSON.parse(data['jsonData'][3]));
        setIsLoading(false);
      });
    }
  }, [radio_buttons_test]);

  useEffect(() => {
    try {
      if (value?.chargingSessionCount?.[0]) {
        set_charging_session_count(JSON.parse(value.chargingSessionCount[0]));
      }
      if (value?.chargingSessionCount?.[3]) {
        setDownloadData(JSON.parse(value.chargingSessionCount[3]));
      }
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
    

    <div style={{ padding: '16px' }}>
    {/* Title + Info */}
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      gap: '8px'
    }}>
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '130px'
      }}>
        <ManText
          className="card-title-text"
          variant="component-l"
          as="span"
          size="l"
          style={{ lineHeight: 'normal' }}
        >
         Charging session count
        </ManText>
      </div>
      <div style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        flexDirection: "row-reverse"
      }}>
        {/* <PopoverComponent
          id="charging_time"
          content={tooltipContent}
        /> */}
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
          <img className="man-logovv1" src={ifav} alt="info" />
        </OverlayTrigger>
        <Zoom
          chartData={charging_session_count?.data}
          chartLayout={charging_session_count?.layout}
          chartTitle="Charging session count"
        />
        <DownloadButtonComponent
          data={downloadData}
          fileName={`charging_session_count_${chartType.toLowerCase()}_${radio_buttons_test?.['Charging Session Count']?.toLowerCase() || 'daily'}.xlsx`}
        />
      </div>
    </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
        <div style={{ flexShrink: 0 }}>
          <AverageDisplay averages={avg_value} unit="sessions" />
        </div>
        <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>   
        <ManRadioButtonGroup
          name="Charging Session Count"
          invalid="false"
          onManChange={handleSelectChange1}
          style={{ display: 'flex', gap: '20px' }}
        >
          <ManRadioButton name="Charging Session Count" label="Daily" value="Daily" checked />
          <ManRadioButton name="Charging Session Count" label="Monthly" value="Monthly" />
          <ManRadioButton name="Charging Session Count" label="Yearly" value="Yearly" />
        </ManRadioButtonGroup>
        </div>
        {/* <div style={{ marginLeft: 'auto' }}>
          <SegmentedControl
            selected={chartType}
            onChange={(type) => setChartType(type)}
            options={["Bar"]}
          />
        </div> */}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
        {isLoading ? (
          <Shimmer_graph />
        ) : (
          charging_session_count && (
            <>
              <Plot
                data={charging_session_count.data}
                layout={{
                  ...charging_session_count.layout,
                  margin: { t: 10, r: 10, l: 10, b: 160 },
                  xaxis: {
                    ...charging_session_count.layout?.xaxis,
                    rangeslider: { visible: false },
                  },
                  autosize: true,
                  responsive: true,
                }}
                useResizeHandler={true}
                style={{ width: '100%', height: '100%' }}
              />
              {/* <CustomTextDisplay
                title="AI | Automotive Intelligence"
                isValueStyled
              /> */}
            </>
          )
        )}
      </div>
    </div>
  );
};

Charging_session_count.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    chargingSessionCount: PropTypes.array.isRequired,
  }).isRequired,
};

export default Charging_session_count;
